import React from 'react';
import { object } from 'prop-types';
import { currencyToSign } from '../../utils/utils';

const propTypes = {
  pixels: object.isRequired,
};

function getMaximumPayoutCallback(acc, val) {
  let currentMax = acc;
  Object.entries(val).forEach(([currency, [min, max]]) => {
    if (typeof currentMax[2] === 'string') {
      return;
    }
    if (typeof max === 'string' || max > currentMax[2]) currentMax = [currency, min, max];
  });
  return currentMax;
}
function MaximumPayout({ pixels = {} }) {
  if (Object.values(pixels).length === 0) return null;

  const allPayouts = Object.values(pixels);
  const maximumPayout = allPayouts.reduce(
    getMaximumPayoutCallback,
    ['', 0, 0], // [currency, min, max]
  );

  const [currency, min, max] = maximumPayout;

  const showCurrency = typeof min === 'number' && typeof max === 'number';

  if (min === max || min === 0) {
    return (
      <>
        {max}
        &nbsp;
        {showCurrency ? currencyToSign(currency) : null}
      </>
    );
  }
  return (
    <>
      {min}
      &ndash;
      {max}
      &nbsp;
      {showCurrency ? currencyToSign(currency) : null}
    </>
  );
}

MaximumPayout.propTypes = propTypes;

export { MaximumPayout };
